type IconMapType = { [key: string]: string };

const RAW_ICON_MAP: IconMapType = {
  'workflow.langchain': '/src/ux-common/public/logos/provider/langchain.svg',
  'workflow.langgraph': '/src/ux-common/public/logos/provider/langchain.svg',
  'workflow.llamaindex': '/src/ux-common/public/logos/provider/LlamaSquareBlack.svg',
  'workflow.haystack': '/src/ux-common/public/logos/provider/haystack.svg',
  'workflow.openai': '/src/ux-common/public/logos/provider/openai.svg',
  'workflow.vercel': '/src/ux-common/public/logos/provider/vercel.svg',
  'workflow.gemini': '/src/ux-common/public/logos/service/google-gemini.svg',
  'workflow.vertexai': '/src/ux-common/public/logos/service/gcp-vertex-ai.svg',
  'workflow.teams_ai': '/src/ux-common/public/logos/service/teams_ai.svg',
  'workflow.generic': '/src/ux-common/public/logos/provider/workflow-generic.svg',
  'workflow.hybrid': '/src/ux-common/public/logos/provider/workflow-hybrid.svg',
  'workflow.anthropic': '/src/ux-common/public/logos/service/anthropic.svg',
  'workflow.crewai': '/src/ux-common/public/logos/service/crewai.svg',
  'workflow.strands': '/src/ux-common/public/logos/service/strands.svg',
  'agent.langgraph': '/src/ux-common/public/logos/service/langgraph.svg',
  'agent.llamaindex': '/src/ux-common/public/logos/provider/LlamaSquareBlack.svg',
  'agent.adk': '/src/ux-common/public/logos/service/google-adk.svg',
  'agent.strands': '/src/ux-common/public/logos/service/strands.svg',
  'agent.crewai': '/src/ux-common/public/logos/service/crewai.svg',
  'agent.microsoft': '/src/ux-common/public/logos/service/microsoft-agent.svg',
  'agent.claude-cli': '/src/ux-common/public/logos/service/claude-cli.svg',
  'agent.codex-cli': '/src/ux-common/public/logos/service/codex-cli.svg',
  'agent.github-copilot': '/src/ux-common/public/logos/service/github-copilot.svg',
  'model.llm': '/src/ux-common/public/logos/model/model_llm.svg',
  'model.embedding': '/src/ux-common/public/logos/model/embedding_model.svg',
  'model.generic': '/src/ux-common/public/logos/provider/model-generic.svg',
  'model.openai': '/src/ux-common/public/logos/provider/openai.svg',
  'model.llama': '/src/ux-common/public/logos/model/meta_llama.svg',
  'model.deepseek': '/src/ux-common/public/logos/model/deepseek.svg',
  'model.custom': '/src/ux-common/public/logos/model/model_custom.svg',
  'model.anthropic': '/src/ux-common/public/logos/model/anthropic.svg',
  'model.mistral': '/src/ux-common/public/logos/model/mistral.svg',
  'app_hosting.aws_lambda': '/src/ux-common/public/logos/provider/lambda.svg',
  'app_hosting.aws_app_runner': '/src/ux-common/public/logos/service/aws-apprunner.svg',
  'app_hosting.github_codespace': '/src/ux-common/public/logos/provider/github-codespace.svg',
  'app_hosting.azure_func': '/src/ux-common/public/logos/service/azure-function.svg',
  'app_hosting.azure_webapp': '/src/ux-common/public/logos/service/azure-webapp.svg',
  'app_hosting.vercel_project': '/src/ux-common/public/logos/provider/vercel.svg',
  'app_hosting.aws_agentcore': '/src/ux-common/public/logos/service/agentcore.svg',
  'app_hosting.azure_ai_foundry': '/src/ux-common/public/logos/service/foundry.svg',
  'inference.nvidia_triton': '/src/ux-common/public/logos/service/triton.svg',
  'compute.kubernetes': '/src/ux-common/public/logos/service/kubernetes.svg',
  'inference.azure_openai': '/src/ux-common/public/logos/service/azure-openai.svg',
  'inference.azure_ai_inference': '/src/ux-common/public/logos/service/azure-openai.svg',
  'inference.openai': '/src/ux-common/public/logos/provider/openai.svg',
  'inference.openai.model': '/src/ux-common/public/logos/provider/openai.svg',
  'inference.aws_bedrock': '/src/ux-common/public/logos/service/bedrock.svg',
  'inference.aws_sagemaker': '/src/ux-common/public/logos/service/sagemaker.svg',
  'inference.gemini': '/src/ux-common/public/logos/service/google-gemini.svg',
  'inference.vertexai': '/src/ux-common/public/logos/service/gcp-vertex-ai.svg',
  'app_hosting.azure_ml': '/src/ux-common/public/logos/service/azure-ml.svg',
  'vectorstore.chroma': '/src/ux-common/public/logos/service/chroma.svg',
  'vectorstore.opensearchvectorsearch': '/src/ux-common/public/logos/service/aws-opensearch.svg',
  'vectorstore.milvus': '/src/ux-common/public/logos/service/milvus.svg',
  'inference.hugging_face': '/src/ux-common/public/logos/provider/hugging-face.svg',
  'inference.anthropic': '/src/ux-common/public/logos/service/anthropic.svg',
  'vectorstore.pinecone': '/src/ux-common/public/logos/service/pinecone.svg',
  'vectorstore.aws_es': '/src/ux-common/public/logos/service/aws-opensearch.svg',
  'experience.msteams': '/src/ux-common/public/logos/service/teams_ai.svg',
  'experience.git': '/src/ux-common/public/logos/provider/github.svg',
  'experience.slack': '/src/ux-common/public/logos/service/slack.svg',
  'experience.instagram': '/src/ux-common/public/logos/service/instagram.svg',
  'experience.whatsapp': '/src/ux-common/public/logos/service/whatsapp.svg',
  'experience.mcp': '/src/ux-common/public/logos/service/mcp.svg',
  'experience.custom': '/src/ux-common/public/logos/service/custom-experience.svg',
  'tool.langgraph': '/src/ux-common/public/logos/service/agentic-tool.svg',
  'tool.llamaindex': '/src/ux-common/public/logos/service/agentic-tool.svg',
  'tool.adk': '/src/ux-common/public/logos/service/agentic-tool.svg',
  'tool.strands': '/src/ux-common/public/logos/service/agentic-tool.svg',
  'tool.crewai': '/src/ux-common/public/logos/service/agentic-tool.svg',
  'tool.microsoft': '/src/ux-common/public/logos/service/agentic-tool.svg',
  'tool.generic': '/src/ux-common/public/logos/service/agentic-tool.svg',
  'tool.mcp': '/src/ux-common/public/logos/service/mcp.svg',
  'mcp.server': '/src/ux-common/public/logos/service/mcp.svg',
  azure: '/src/ux-common/public/logos/provider/microsoft-azure.svg',
  aws: '/src/ux-common/public/logos/provider/aws.svg',
  github: '/src/ux-common/public/logos/provider/github.svg',
  gcp: '/src/ux-common/public/logos/provider/gcp.svg',
  openai: '/src/ux-common/public/logos/provider/openai.svg',
  nvidia: '/src/ux-common/public/logos/provider/nvidia.svg',
  hugging_face: '/src/ux-common/public/logos/provider/hugging-face.svg',
  vercel: '/src/ux-common/public/logos/provider/vercel.svg',
  anthropic: '/src/ux-common/public/logos/service/anthropic.svg',
  'okahu-icon': '/src/ux-common/public/logos/okahu.svg',
  'start-icon': '/src/ux-common/public/logos/play.svg',
  'end-icon': '/src/ux-common/public/logos/stop.svg',
  'error-badge': '/src/ux-common/public/logos/error-badge.svg',
  default: '/src/ux-common/public/logos/provider/not-available.svg',
};

const UX_COMMON_PUBLIC_PREFIX = '/src/ux-common/public';

const normalizePublicPath = (value: string) =>
  value.startsWith(UX_COMMON_PUBLIC_PREFIX)
    ? value.replace(UX_COMMON_PUBLIC_PREFIX, '')
    : value;

export const iconMap: IconMapType = Object.fromEntries(
  Object.entries(RAW_ICON_MAP).map(([key, value]) => [key, normalizePublicPath(value)])
) as IconMapType;